import styles from './LoadingSpinner.module.css'

interface LoadingSpinnerProps {
  label?: string
  size?: 'sm' | 'md' | 'lg'
}

export function LoadingSpinner({ label, size = 'md' }: LoadingSpinnerProps) {
  return (
    <div className={styles.wrapper}>
      <div className={`${styles.spinner} ${styles[size]}`} aria-label="Loading" />
      {label && <span className={styles.label}>{label}</span>}
    </div>
  )
}
